module.exports = __webpack_public_path__ + "static/media/rekening_mas.eb821d6a.png";